import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { FeatureEnum } from 'src/app/samwebDescription/samwin/FeatureEnum';
import { EnabledFeaturesState } from 'src/app/store/session/enabled-features/enabled-features.state';

@Component({
   selector: 'samweb-email-confirm-close-dialog',
   templateUrl: './email-confirm-close-dialog.component.html',
   styleUrls: ['./email-confirm-close-dialog.component.scss'],
})
export class EmailConfirmCloseDialogComponent implements OnInit {
   @Select(EnabledFeaturesState.isFeatureEnabled(FeatureEnum.ALLOW_TO_REASSIGN_EMAIL))
   public isFeatureEnabled$: Observable<boolean>;

   @Output()
   public complete = new EventEmitter();

   @Output()
   public reassign = new EventEmitter();

   @Output()
   public cancel = new EventEmitter();

   constructor() {}

   ngOnInit(): void {}

   onComplete() {
      this.complete.emit();
   }

   onReassign() {
      this.reassign.emit();
   }

   onCancel() {
      this.cancel.emit();
   }
}
